import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { NO_MOUNTING_RAIL, NO_UPRIGHTS } from "../constants/errors";
import { getDiagonalBracketConnectorKey, getSectionUprightsByUpright, hostingUprightIsPartOfSection, } from "../utils/sectionsHelpers";
import { getRightUprightsOffsetFromLeft } from "../functions/interactiveBoaxelSection";
import { calculateLeftUprightConnections } from "../functions/HoleOccupation";
import { generateValidationFail, entityIsAdjustableShelf, } from "../utils/helpers";
import { getConnectorsComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
const FAIL_MSG = "Adjustable shelf can't sit here";
export default class AdjustableShelfPlacementValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.id = "AdjustableShelfPlacementValidation";
        this.validateRightUpright = ({ hostConnector, guestConnector }, rightUpright) => {
            var _a;
            const rightUprightConnector = getConnectorsComponent(rightUpright).getConnectorByKey(hostConnector.key);
            if (!rightUprightConnector)
                return false;
            const rightUprightConnectorsComponent = (_a = rightUpright.getComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections;
            if (!rightUprightConnectorsComponent)
                return true;
            const [firstId, secondId] = [
                hostConnector.key,
                getDiagonalBracketConnectorKey(hostConnector.key, guestConnector.key),
            ].map((connectorKey) => {
                var _a;
                return ((_a = rightUprightConnectorsComponent.find(({ hostConnector }) => hostConnector.key === connectorKey)) === null || _a === void 0 ? void 0 : _a.guestConnectorEntity.id) || false;
            });
            return (!firstId && !secondId) || firstId === secondId;
        };
        this.adjustableFitsBetweenUprights = (snapActionCandidate) => {
            const { guest, host } = snapActionCandidate;
            const { rightUpright } = getSectionUprightsByUpright(host);
            if (!rightUpright)
                throw new Error(NO_UPRIGHTS);
            const mountingRail = HierarchyUtils.parent(rightUpright);
            if (!mountingRail)
                throw new Error(NO_MOUNTING_RAIL);
            const sectionWidth = getRightUprightsOffsetFromLeft(mountingRail, rightUpright);
            const minMaxWidth = guest.getComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT);
            if (!minMaxWidth)
                return true;
            const { min, max } = minMaxWidth;
            return !(sectionWidth < min || sectionWidth > max);
        };
    }
    validateCurrentState(_entity) {
        return null;
    }
    validateSnap(snapActionCandidate) {
        if (!entityIsAdjustableShelf(snapActionCandidate.guest))
            return null;
        const { host } = snapActionCandidate;
        if (!hostingUprightIsPartOfSection(host) ||
            !this.adjustableFitsBetweenUprights(snapActionCandidate))
            return generateValidationFail(snapActionCandidate.guest, FAIL_MSG);
        const { rightUpright } = getSectionUprightsByUpright(snapActionCandidate.host);
        if (!rightUpright)
            throw new Error(NO_UPRIGHTS);
        const rightIsValid = this.validateRightUpright(snapActionCandidate, rightUpright);
        const leftIsValid = calculateLeftUprightConnections(snapActionCandidate, rightUpright);
        if (leftIsValid && rightIsValid)
            return null;
        return generateValidationFail(snapActionCandidate.guest, FAIL_MSG);
    }
}
